import { render } from "./CameraScanQRCodeDialog.vue?vue&type=template&id=4d49a547&scoped=true"
import script from "./CameraScanQRCodeDialog.vue?vue&type=script&lang=js"
export * from "./CameraScanQRCodeDialog.vue?vue&type=script&lang=js"

import "./dialog.scss?vue&type=style&index=0&id=4d49a547&lang=scss&scoped=true"
import "./CameraScanQRCodeDialog.vue?vue&type=style&index=1&id=4d49a547&lang=css"

import exportComponent from "/Users/tathonglam/docker/src/client/weconcept/star168.hk/star168_backend.git/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d49a547"]])

export default __exports__